<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="加工单列表"
      id-key="UserId"
      @close-saved="$emit('close-saved')"
      
    >

       <list ref="list"  :tableType="1"  :temp-params="{Statuses :[3,4],LineAbort: false,Stage: Stage, ProductionType: 1, OrderType, TradeUnitName: TradeUnitName }" disabled TradeUnitDisabled></list>  
      
       <div slot="footer">
          <el-button type="primary" @click="saved">保存</el-button>
       </div>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import list from "@/views/business/stock/workList/index";



// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    list,
  },
  props: {
    DictionaryId:{
      type: Number,
      default: 0,
    },
    Stage: {
      type: Number,
      default: 0,
    },
    OrderType: {
      type: Number,
      default: 0,
    },
    TradeUnitName: {
      type: String,
      default: null,
    }
    

  },
  methods: {
    get_data(o){
      console.log('o', o)
      this.$refs.list.$refs.list.query(o)
    },
    saved(){
     let list = this.$refs.list.list;
      let subList = this.$refs.list.subList;
      let extraList = this.$refs.list.extraList;

      let TradeUnitId = this.$refs.list.TradeUnitId;
      this.$emit('saved', {
        list,
        subList,
        extraList,
        TradeUnitId,
      });
      this.close();
    }
  }
  
};
</script>
